import SvgIcon from '@/components/SvgIcon'
import Vue from 'vue'
Vue.component('svg-icon', SvgIcon)

// 1. 打印路径
const req = require.context('./svg', false, /\.svg$/)

// 2. 强制执行
req.keys().forEach(req)
